import {createTableState, normalizePagination} from '@/core/services/Helper'

const state = () => ({
    table: createTableState(),
    filterData: undefined
})

const getters = {}

const actions = {
    // Element listesi: form/element controller'ında index YOK. Elemanlar formun
    // show yanıtına gömülü gelir (slider buton / popup buton mantığı). form_id
    // filterData içinde gönderilir; form show edilip elemanları çıkarılır.
    async get({state, commit}, {filterData}) {
        commit('setLoading', true)
        state.filterData = filterData

        const formId = filterData?.form_id
        let elements = []
        if (formId) {
            const res = await this._vm.axios.get(this._vm.endpoint.get('module_form') + '/' + formId)
            const form = res.data?.data || {}
            elements = form.elements || form.form_elements || form.items || form.element || null
            if (!Array.isArray(elements)) {
                // bilinen anahtar yoksa: type_id içeren ilk diziyi yakala
                elements = Object.values(form).find(v =>
                    Array.isArray(v) && v.length && v[0] && typeof v[0] === 'object' && 'type_id' in v[0]
                ) || []
            }
        }

        commit('updateTableData', elements)
        commit('updatePagination', normalizePagination(null))

        setTimeout(() => commit('setLoading', false), 250)
    },

    refresh({state, dispatch}) {
        dispatch('get', {page: state.table.pagination, filterData: state.filterData})
    },

    async show(_, {id}) {
        const response = await this._vm.axios.get(this._vm.endpoint.get('module_form_element') + '/' + id)
        return response.data.data
    },

    // payload: {form_id, type_id, translate, options, sort, active} (translate nested)
    async create(_, {data}) {
        const response = await this._vm.axios.post(this._vm.endpoint.get('module_form_element'), data)
        return response.data
    },

    // payload: {translate, options, sort, active}
    async put(_, {id, data}) {
        const response = await this._vm.axios.put(this._vm.endpoint.get('module_form_element') + '/' + id, data)
        return response.data
    },

    async delete(_, {id}) {
        const {data} = await this._vm.axios.delete(this._vm.endpoint.get('module_form_element') + '/' + id)
        if (data.status) {
            this._vm.$message.success(this._vm.$t('messages.deleteOk'))
        } else {
            this._vm.$message.error(data.message)
        }
        return data
    },
}

const mutations = {
    setLoading(state, val) {
        state.table.loading = val
    },
    updatePagination(state, pagination) {
        state.table.pagination = pagination
    },
    updateTableData(state, data) {
        state.table.data = data
    }
}

export default {namespaced: true, state, getters, actions, mutations}
